import React, { useState } from 'react';

const AdminTest: React.FC = () => {
  const [clickCount, setClickCount] = useState(0);
  const [message, setMessage] = useState('Admin Test Component Loaded');

  const handleTestClick = () => {
    console.log('Test button clicked!');
    setClickCount(prev => prev + 1);
    setMessage(`Button clicked ${clickCount + 1} times`);
  };

  const handleTabTest = (tabName: string) => {
    console.log(`Tab ${tabName} clicked!`);
    setMessage(`${tabName} tab clicked at ${new Date().toLocaleTimeString()}`);
  };

  return (
    <div style={{
      padding: '2rem',
      fontFamily: 'Arial, sans-serif',
      maxWidth: '800px',
      margin: '0 auto'
    }}>
      <h1>Admin Dashboard Test</h1>
      <p>Status: {message}</p>
      
      <div style={{ margin: '2rem 0', display: 'flex', gap: '1rem' }}>
        <button 
          onClick={handleTestClick}
          style={{
            padding: '1rem 2rem',
            fontSize: '1rem',
            background: '#3b82f6',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer'
          }}
        >
          Test Click ({clickCount})
        </button>
        
        <button 
          onClick={() => handleTabTest('Brokers')}
          style={{
            padding: '1rem 2rem',
            fontSize: '1rem',
            background: '#10b981',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer'
          }}
        >
          🏢 Brokers Test
        </button>
        
        <button 
          onClick={() => handleTabTest('Platforms')}
          style={{
            padding: '1rem 2rem',
            fontSize: '1rem',
            background: '#8b5cf6',
            color: 'white',
            border: 'none',
            borderRadius: '8px',
            cursor: 'pointer'
          }}
        >
          💻 Platforms Test
        </button>
      </div>

      <div style={{
        background: '#f3f4f6',
        padding: '1rem',
        borderRadius: '8px',
        marginTop: '2rem'
      }}>
        <h3>Debug Info:</h3>
        <p>React Version: {React.version}</p>
        <p>Current Time: {new Date().toLocaleString()}</p>
        <p>User Agent: {navigator.userAgent.substring(0, 50)}...</p>
        <p>Local Storage Available: {typeof(Storage) !== "undefined" ? "Yes" : "No"}</p>
      </div>

      <div style={{ marginTop: '2rem' }}>
        <a 
          href="/admin" 
          style={{
            display: 'inline-block',
            padding: '1rem 2rem',
            background: '#ef4444',
            color: 'white',
            textDecoration: 'none',
            borderRadius: '8px'
          }}
        >
          Back to Real Admin Dashboard
        </a>
      </div>
    </div>
  );
};

export default AdminTest;